import {Component, OnInit, ViewChild} from '@angular/core';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {environment} from '../../../../../environments/environment';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UntypedFormGroup} from '@angular/forms';
import {Fabric} from '../../../Models/Fabric';
import {FabricService} from '../../../Services/fabric.service';
import {FabricCollectionService} from '../../../Services/fabric-collection.service';
import {Product} from '../../../Models/Product';
import {FabricCollection} from '../../../Models/FabricCollection';

@Component({
  selector: 'app-manage-fabric',
  templateUrl: './manage-fabric.component.html',
  styleUrls: ['./manage-fabric.component.scss']
})
export class ManageFabricComponent implements OnInit {
  public fabric: Fabric = new Fabric();
  public classicBox;
  public lastValue = <any>{};
  public enableSave = true;
  form = new UntypedFormGroup({});
  public fabricCollectionId: number;
  public fabricId: number;
  public isEdit = false;
  public fabricCollectionOptions = [];
  public fabricCollection: FabricCollection = new FabricCollection();
  public fabricCollectionCopy: FabricCollection[] = [];
  options: FormlyFormOptions = {};
  @ViewChild('classicForm', {static: false}) child;


  constructor(
    private route: ActivatedRoute,
    public helper: Helper,
    private translate: TranslateService,
    private fabricService: FabricService,
    private fabricCollectionService: FabricCollectionService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      // new
      new Promise ((resolve, reject) => {
        if (!Helper.isDefined(params['fabricId'])) {
          // get id fabricCollection
          this.fabricCollectionId = params['id'];
          // data
          this.fabricCollectionService.getFabricCollectionItem(this.fabricCollectionId).subscribe((res) => {
            const fabric = new Fabric();
            fabric.fabricCollection = +this.fabricCollectionId;
            this.fabricCollection = res;
            resolve(fabric);
          });

          // edit
        } else {
          this.fabricCollectionId = params['id'];
          this.fabricId = params['fabricId'];
          this.isEdit = true;
          this.fabricService.getFabricItem(this.fabricId).subscribe(resp => {
            resp.fabricCollection = resp.fabricCollection.id;
            resolve(resp);
          });
        }
      }).then(fabricCollection => {
        this.lastValue = {fabric: fabricCollection};
      }).then(() => {
        this.fabricCollectionService.getFabricCollectionList().subscribe((resp) => {
          this.fabricCollectionCopy = resp.data;
          resp.data.map((value) => {
            this.fabricCollectionOptions.push({
              label: value.name,
              value: value.id
            });
            if (Helper.isDefined(this.fabricCollectionId)) {
              this.lastValue.fabricCollection = this.fabricCollectionId;
            }
          });
          this.classicBox = <FormlyFieldConfig>[
            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('doctrine.fabric.fabric_details') + '</strong></div><hr/>',
            },
            {
              fieldGroupClassName: 'row',
              key: 'fabric',
              fieldGroup: [
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'name',
                  templateOptions: {
                    label: this.translate.instant('doctrine.fabric.name'),
                    required: true,
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) =>
                        this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
                {
                  key: 'fabricCollection',
                  type: 'ng-select',
                  className: 'col-3 ',
                  templateOptions: {
                    required: true,
                    label: this.translate.instant('doctrine.fabric.fabric_collection'),
                    options: this.fabricCollectionOptions,

                  },
                  hooks: {
                    onInit: (field) => {
                      const { form } = field;
                      field.formControl.valueChanges.subscribe((res) => {
                        if (res) {
                          if (!form.get('overwriteCollectionPrice').value) {
                            form.get('dealerPrice')
                              .setValue(this.fabricCollectionCopy[this.fabricCollectionCopy.findIndex(x => x.id == res)].dealerPrice);
                            form.get('customerPrice')
                              .setValue(this.fabricCollectionCopy[this.fabricCollectionCopy.findIndex(x => x.id == res)].customerPrice);
                          }
                        }
                      });
                    },
                  },
                },
              ],
            },
            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('doctrine.fabric.price') + '</strong></div><hr/>',
            },
            {
              fieldGroupClassName: 'row',
              key: 'fabric',
              fieldGroup: [

                {
                  className: 'col-3',
                  type: 'checkbox',
                  key: 'overwriteCollectionPrice',
                  templateOptions: {
                    label: this.translate.instant('doctrine.fabric.overwrite'),
                    options: [
                      {label: Product.PRODUCT_ACTIVE, value: true},
                      {label: Product.PRODUCT_INACTIVE, value: false},
                    ],
                  },
                  hooks: {
                    onInit: (field) => {
                      const { form } = field;
                      field.formControl.valueChanges.subscribe((res) => {
                        if (!res) {
                          const value = form.get('fabricCollection').value;
                          form.get('dealerPrice')
                            .setValue(this.fabricCollectionCopy[this.fabricCollectionCopy.findIndex(x => x.id == value)].dealerPrice);
                          form.get('customerPrice')
                            .setValue(this.fabricCollectionCopy[this.fabricCollectionCopy.findIndex(x => x.id == value)].customerPrice);
                        }
                      });
                    },
                  },
                },
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'dealerPrice',
                  defaultValue: this.fabricCollection.dealerPrice,
                  templateOptions: {
                    label: this.translate.instant('doctrine.fabric.dealer_price'),
                    required: true,
                    addonLeft: {
                      text: this.translate.instant('global.currency_sign'),
                    },
                    pattern: '^\\d{0,8}\\.\\d{1,4}$|^\\d{0,11}$',
                    maxLength: environment.maxStringLength,
                  },
                  expressionProperties: {
                    'templateOptions.disabled': (model: any) => {
                      if (model !== undefined && model != null) {
                        return !(model.overwriteCollectionPrice);
                      }
                    },
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) =>
                        this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'customerPrice',
                  defaultValue: this.fabricCollection.customerPrice,
                  templateOptions: {
                    label: this.translate.instant('doctrine.fabric.customer_price'),
                    required: true,
                    addonLeft: {
                      text: this.translate.instant('global.currency_sign'),
                    },
                    pattern: '^\\d{0,8}\\.\\d{1,4}$|^\\d{0,11}$',
                    maxLength: environment.maxStringLength,
                  },
                  expressionProperties: {
                    'templateOptions.disabled': (model: any) => {
                      if (model !== undefined && model != null) {
                        return !(model.overwriteCollectionPrice);
                      }
                    },
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) =>
                        this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
              ],
            },


            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('doctrine.fabric.other') + '</strong></div><hr/>',
            },
            {
              fieldGroupClassName: 'row',
              key: 'fabric',
              fieldGroup: [
                {
                  key: 'status',
                  type: 'ng-select',
                  className: 'col-3 ',
                  defaultValue: true,
                  templateOptions: {
                    label: this.translate.instant('doctrine.fabric.status'),
                    required: true,
                    options: [
                      {label: this.translate.instant('global.active'), value: true},
                      {label: this.translate.instant('global.inactive'), value: false},
                    ],
                  },
                },
              ],
            }
          ];
        });
      });
    });

  }

  enableButton(event) {
    this.enableSave = event;
  }

  submitItem(next: boolean) {
    if (next) {
      const fabric = JSON.parse(JSON.stringify(this.lastValue));
      delete fabric.fabric.id;
      delete fabric.fabric.attachedColors;
      delete fabric.fabric.fabricColors;
      this.fabricService.manageFabric(fabric, this.isEdit, this.fabricId).subscribe((resp) => {
        this.router.navigateByUrl('/back-office/fabric-collection/' + this.fabricCollectionId + '/show');

      });
    } else {
      this.router.navigateByUrl('/back-office/fabric-collection/' + this.fabricCollectionId + '/show');

    }
  }
}
